import { render, staticRenderFns } from "./AddPublication.vue?vue&type=template&id=3788f544&"
import script from "./AddPublication.js?vue&type=script&lang=js&"
export * from "./AddPublication.js?vue&type=script&lang=js&"
import style0 from "./AddPublication.vue?vue&type=style&index=0&id=3788f544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports